import React from 'react';
import './listPage.css';

/**
 * Φίλτρο του ListToolbar (Κατάσταση, Πηγή, Τύπος): εγγενές <select> στο ύψος της αναζήτησης. Όταν
 * φιλτράρει (τιμή ≠ ''), το περίγραμμα και το κείμενο παίρνουν το χρώμα της εφαρμογής — φαίνεται με μια
 * ματιά ότι η λίστα δεν είναι «όλα». Το όνομα (label) το ακούει ο αναγνώστης οθόνης· οι επιλογές το λένε
 * ήδη με κείμενο («Όλες οι καταστάσεις»), γι' αυτό δεν υπάρχει ορατή ετικέτα.
 */

export interface FilterOption {
  value: string;
  label: string;
}

export interface FilterSelectProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: FilterOption[];
  /** Πρώτη επιλογή με τιμή '' (π.χ. «Όλες οι καταστάσεις»). */
  allLabel?: string;
  disabled?: boolean;
  testId?: string;
}

export const FilterSelect: React.FC<FilterSelectProps> = ({ label, value, onChange, options, allLabel, disabled = false, testId }) => (
  <select
    className="lp-select"
    aria-label={label}
    title={label}
    value={value}
    disabled={disabled}
    data-active={value !== '' ? 'true' : undefined}
    data-testid={testId}
    onChange={e => onChange(e.target.value)}
  >
    {allLabel !== undefined && <option value="">{allLabel}</option>}
    {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
  </select>
);

export default FilterSelect;
